import axios from 'axios';

function modal(title, content){

    $("#error_message").find("#modalTitle").html(title);
    $("#error_message").find(".modalContent").html(content);

    $('#error_message').foundation('open');


}

export const AxiosApi = async (data_send) => {

    var uniq = 'id' + (new Date()).getTime();
    $(".serverSend").append("<div id='" + uniq + "'>Odesílám data na server... " + uniq + "</div>");

    const response = await axios.get("/ZasShopServicePage.aspx/"+data_send, {
        headers: {
            'Accept': '*/*',
        }
    })
    const responseData = response.data

    if(responseData.error_code) {

        var message =  responseData.error_message;
        message = message.split(";");

        if(message.length !== 1) {
            var title = message[0].replace("#ZSHOP_ERROR_TITLE=", "");
            var text = message[1].replace("#ZSHOP_ERROR=", "");
            var id = message[2].replace("#ZSHOP_ERROR_DELETE_ID=", "");
            var content = "<p>" + text + "</p><p>Objednávka číslo: " + id + "</p>";
        } else {
            var title = "Omlouváme se objevila se chyba";
            var content = "<p>" + message + "</p><p>V případě problému obraťte se na naší podporu <a href='mailto:objednavky@proform.eu?subject=Chyba%20konfiguratoru&body=" + message + "'>objednavky@proform.eu</a></p>";
        }

        modal(title, content);
        $("#" + uniq).addClass("error");
        $("#" + uniq).html(content);

        return false;
    } else {
        $("#" + uniq).addClass("succes");
        $("#" + uniq).html("Odesláno v pořádku");
        setTimeout( function() {
            $("#" + uniq).hide();
        }, 1000)
        return responseData;
    }

}